
import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import Navbar from './components/Navbar';
import Preloader from './components/Preloader';
import CursorBlob from './components/CursorBlob';
import NeonCursor from './components/NeonCursor';
import RainBackground from './components/RainBackground';
import SiteBlob from './components/SiteBlob';
import Home from './pages/Home';
import Projects from './pages/Projects';
import About from './pages/About';
import Contact from './pages/Contact';
import Footer from './components/Footer';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() =>{
    AOS.init({duration:800, once: true, easing: 'fade-in'});
  })
  return (
    <>
      {loading && <Preloader onDone={() => setLoading(false)} />}
      <NeonCursor />
      <RainBackground />
      <SiteBlob />
      <CursorBlob />
      <Navbar visible={!loading} />
      <main>
        <section id="home"><Home ready={!loading} /></section>
        <section id="about"><About /></section>
        <section id="projects"><Projects /></section>
        <section id="contact"><Contact /></section>
      </main>
      <Footer/>
    </>
  );
}

export default App;
